module.exports = __webpack_public_path__ + "img/logo.d130b602.png";